import {Component, OnInit} from '@angular/core';
import {ProductService} from '../../services/product/product.service';
import {UserService} from '../../services/user/user.service';
import {User} from '../../models/user';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    standalone: false
})
export class DashboardComponent implements OnInit {

  user: User;

  constructor(private userService: UserService, private productService: ProductService) {
    this.userService.getUserProfile().subscribe((user) => {
        this.user = user;
      }
    );
  }

  ngOnInit(): void {
  }

}
